module.exports = __webpack_public_path__ + "img/feifan_home.66bb0f7a.png";